<template>

  <div class="variables-list">
    <v-checkbox v-for="variable in options"
                :key="variable"
                :disabled="readonly"
                :label="$t(`variable.${variable}`)"
                :value="variable"
                :input-value="value"
                @change="change($event)"
    />

    <no-data v-if="!options.length" medium>{{ $t('assets.no-variables') }}</no-data>
  </div>

</template>

<script>
  import NoData from '../../../shared/no-data'

  export default {
    name: 'variables-list',

    props: [ 'options', 'value', 'readonly' ],

    methods: {
      change (event) {
        this.$emit('input', event)
        this.$emit('change', event)
      }
    },

    components: {
      NoData
    }
  }
</script>

<style scoped lang="scss">

  .variables-list {
    height: 100%;
  }

  ::v-deep {
    .v-input {
      &:not(:first-child) {
        margin-top: 0;
      }

      .v-messages {
        display: none;
      }
    }
  }

</style>
